import * as React from "react";
import { IFloatingTool } from "source/app/presentation/Shared/FloatingTools/FloatingTools";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "../../../../services/UI/State/State";
import { ILogMonumentalState } from "../ILogMonumentalState";
import { ArrayUtils } from "../../../../services/ArrayUtils";
import UI from "source/app/services/UI/UI";

export const logMonumentalFloatingTools: IFloatingTool<{}>[] = [
    {
        name: `workflowsRandom`,
        toRender: () => (
            <IconWithText
                iconSuffix={EGlyphicon["random"]}
                whenClicked={() => HighlightRandomMonumentalLogEntry()}
                displayAsBlock={false}
            />
        ),
        iconColor: `greenyellow`,
        tooltip: `Select random monumental log entry`,
    },
];

export function HighlightRandomMonumentalLogEntry() {
    const logMonumental = State.ReadClass<ILogMonumentalState>(
        ESharedComponent.LogMonumental
    );

    if (!logMonumental) {
        return;
    }

    const logEntries = logMonumental.state.displayedRows;
    const randomLogEntryId = ArrayUtils.GetRandomElement(logEntries).id;

    logMonumental.setState({ randomLogEntryId }, () => {
        const topOffset = -0.6 * (window.outerHeight / 2);

        UI.ScrollToDiv(
            `#scrollTarget_logMonumental_${randomLogEntryId}`,
            topOffset
        );
    });
}
